import React from 'react';
import { Link } from 'react-router-dom';
import '../Achievements.styles.css';

export interface AchievementFooterProps {
  isRecruiterActive?: boolean;
}

// * [COMPONENT] Compact black footer at the bottom of the achievements section
// ? Compressed version of the main Footer — same links, minimal height, avoids bottom-right zoom HUD
export const AchievementFooter: React.FC<AchievementFooterProps> = ({
  isRecruiterActive: propIsRecruiterActive,
}) => {
  const currentYear = new Date().getFullYear();
  const [isRecruiterActive, setIsRecruiterActive] = React.useState<boolean>(
    Boolean(propIsRecruiterActive)
  );

  React.useEffect(() => {
    if (typeof propIsRecruiterActive === 'boolean') {
      setIsRecruiterActive(propIsRecruiterActive);
    }
  }, [propIsRecruiterActive]);

  React.useEffect(() => {
    const handleRecruiterChange = (e: Event): void => {
      const detail = (e as CustomEvent)?.detail;
      if (detail && typeof detail.active === 'boolean') {
        setIsRecruiterActive(detail.active);
      }
    };
    window.addEventListener('recruiter-mode-change', handleRecruiterChange);
    return () => window.removeEventListener('recruiter-mode-change', handleRecruiterChange);
  }, []);

  const handleOpenCookieSettings = (): void => {
    window.dispatchEvent(new CustomEvent('open-cookie-settings'));
  };

  const handleSectionClick = (e: React.MouseEvent, sectionId: string): void => {
    e.preventDefault();
    window.dispatchEvent(
      new CustomEvent('navigate-section', { detail: { targetId: sectionId } })
    );
  };

  return (
    <footer className="achievement-footer">
      <div className="achievement-footer-inner">
        {/* * Compact link row */}
        <div className="achievement-footer-links">
          <a href="/#home" onClick={(e) => handleSectionClick(e, 'home')}>Home</a>
          <a href="/#about" onClick={(e) => handleSectionClick(e, 'about')}>About</a>
          <a href="/#projects" onClick={(e) => handleSectionClick(e, 'projects')}>Projects</a>
          {isRecruiterActive && (
            <a href="/#experience" onClick={(e) => handleSectionClick(e, 'experience')}>Experience</a>
          )}
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <button
            type="button"
            onClick={handleOpenCookieSettings}
            className="achievement-footer-cookie-btn"
          >
            Cookies
          </button>
          <a href="https://github.com/yashasvi9199" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          <a href="mailto:yashaldiya@gmail.com">Email</a>
        </div>

        {/* * Copyright bar */}
        <div className="achievement-footer-copy">
          <span>&copy; {currentYear} Yash Haldiya. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default AchievementFooter;
